import config from '@config'
import { useParams } from '@stores/params'

export const useGEBRetailer = () => {
  const [{ retailerPartnerNumber }] = useParams()
  return config.userAccountByProvider.gigya.rpn.includes(Number(retailerPartnerNumber))
}
